import Handlebars from '@sparta.global.vendors/handlebars';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { checkbox } from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import createBarkerSvg from '@sparta.credit-cards.utilities/barker-utility/dist/es6.js';
import starRating from '@sparta.credit-cards.utilities/star-rating-utility/dist/es6.js';

const linkHelper = link;

/**
 *  Current campaign
 * @param {String} campaignKey - 4020247~87~en_US
 * @param {Object} campaigns - Mapping of response payloads from ProductProperties
 * @param {Object} options - Options
 * @return {Object} options.fn({})
 */
function currentCampaign(campaignKey, campaigns, options) {
  return options.fn({});
}

/**
 * Get object value
 * @param {Object} obj object
 * @param {string} val value
 * @return {string} objectValue
 */
function getObjectValue(obj, val) {
  if (obj) {
    return obj[val];
  }
  return '';
}

/**
 * Strip tag
 * @param  {String} value value
 * @returns {String} innerHTML
 */
function stripTag(value) {
  const div = document.createElement('div');
  div.innerHTML = value;
  div.innerHTML = div.innerHTML.replace('<p>', '').replace('</p>', '').replace('<h1>', '').replace('</h1>', '').replace('<h2>', '').replace('</h2>', '').replace('<h3>', '').replace('</h3>', '').replace('<h4>', '').replace('</h4>', '').replace('<h5>', '').replace('</h5>', '').replace('<h6>', '').replace('</h6>', '');
  return div.innerHTML;
}

/**
 * Strip List
 * @param  {String} value value
 * @returns {String} innerHTML
 */
function stripList(value) {
  const div = document.createElement('div');
  div.innerHTML = value;
  div.innerHTML = div.innerHTML.replace('<ul>', '').replace('</ul>', '').replace('<li>', '').replace('</li>', '');
  return div.innerHTML;
}

/**
 * Network benefits header
 * @param {String}ref reference
 * @param {Object} campaignProperties Campaign properties
 * @param {Object} options options
 * @returns {String} string
 */
function premiumBenefitsHead(ref, campaignProperties, options) {
  let data;
  if (!campaignProperties || Object.keys(campaignProperties).indexOf('name') !== -1) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (ref.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_HEADER_XX = campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_INACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
  return null;
}

/**
 * Network benefits content
 * @param {String} ref reference
 * @param {Object} campaignProperties campaign properties object
 * @param {Object} options options
 * @returns {String} string
 */
function premiumBenefitsContent(ref = '', campaignProperties, options) {
  let data;
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (ref.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_HEADER_XX = campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_CONTENT${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_CONTENT_XX = campaignProperties[`NETWORK_BENEFITS_CONTENT${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
  return null;
}

/**
 * Network benefits icons
 * @param {String} ref ref
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @returns {String} string
 */
function premiumBenefitsIcon(ref = '', campaignProperties, options) {
  let data;
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (ref.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_INACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(data);
  }
  return null;
}

/**
 * Current offer
 * @param {campaignKey} campaignKey campaignKey
 * @param {offers} offers offers
 * @param {options} options options
 * @returns {Boolean|String} returns a boolean or string
 */
function currentOffer(campaignKey, offers, options) {
  // Create cache
  let cache;

  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // if offer campaign code
    if (offerCampaignKey === campaignKey) {
      cache = offer;
    }
  }
  // If undefined
  if (cache === undefined) {
    return false;
  }
  // Return options
  return options.fn(cache);
}

/**
 * Current offers based off query params
 * @param  {Object} queries queries
 * @param  {Array} offers offers
 * @param  {Object} options options
 * @returns {String} string
 */
function currentOfferBasedOffQueryParams(queries, offers, options) {
  // Read pocode
  const poCode = queries.termspocode.value;

  // Read campaign id
  const campaignID = queries.termscampaignid.value;

  // Create cache
  let cache;

  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // request terms and conditions params
    const queryParamsCampaignKey = `${campaignID}~${poCode}`;

    // if offer campaign code
    if (offerCampaignKey === queryParamsCampaignKey) {
      cache = offer;
    }
  }
  // If undefined
  if (cache === undefined) {
    return options.fn({});
  }
  return options.fn(cache);
}

/**
 * Omit offers
 * @param {Object} campaignKey campaign key
 * @param {Array} offers offers
 * @param {Object} options options
 * @return {void}
 */
function omitOffers(campaignKey, offers, options) {
  // Cache array
  const cache = [];
  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // if offer campaign code
    if (offerCampaignKey !== campaignKey) {
      cache.push(offer);
    }
  }
  // Return options
  return options.fn(cache);
}

/**
 * Current campaign
 * @param {String} campaignKey - 4020247~87~en_US
 * @param {Object} campaigns - Mapping of response payloads from ProductProperties
 * @param {Object} options - Options
 * @returns {String} string
 */
function omitCampaign(campaignKey, campaigns, options) {
  return options.fn({});
}

/**
 * Active page scrolling
 * @param {Array} offers offers
 * @param {*} options options
 * @return {String} innerHTML
 */
function activePageScrolling(offers, options) {
  if (offers.length === 1) {
    return options.fn({});
  }
  return options.fn(offers);
}

/**
 * @description Return the value for a single token if available in provided object. Otherwise, return token string.
 * @param {String} key key
 * @param {Object} campaignProperties properties
 * @param {Object} options options
 * @return {String} string
 */
function token(key, campaignProperties, options) {
  // if no object map is passed, throw an error.
  if (!campaignProperties || !Object.keys(campaignProperties).length) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  const tokenPattern = /\$\{([^}]*)\}/;
  const parsedKey = tokenPattern.test(key) ? key.match(tokenPattern)[1] : key;
  if (!!campaignProperties[parsedKey]) {
    return campaignProperties[parsedKey];
  }
  if (typeof options === 'undefined') {
    options = {
      hash: {}
    };
  }
  if (!!options.hash.showEmpty && options.hash.showEmpty !== 'false') {
    return '';
  }
  return key;
}

/**
 * @param {String} key key
 * @param {Object} campaignProperties properties
 * @param {Object} options options
 * @return {Boolean} boolean
 */
function tokenPopulated(key, campaignProperties, options) {
  // if no object map is passed, throw an error.
  if (!campaignProperties || !Object.keys(campaignProperties).length) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  const tokenPattern = /\$\{([^}]*)\}/;
  const parsedKey = tokenPattern.test(key) ? key.match(tokenPattern)[1] : key;
  return !!campaignProperties[parsedKey];
}

/**
 * applyNow
 * @param {Object} applyLink JCR content in sparta link format
 * @param {String} requestType C or BCC
 * @param {String} campaignId Campaign id
 * @param {Object} site spaParams.siteParams
 * @param {Object} sparta global sparta obj
 * @param {Boolean} isBya before you apply link or not
 * @param {Object} catalog = null
 * @param {String} performanceMeta empty string
 * @return {String} string
 */
function applyNow(applyLink, requestType, campaignId, site, sparta, isBya = false, catalog = null, performanceMeta = '') {
  let url = '';
  const queryString = window.location.search.substring(1);
  if (isBya) {
    url += `${site.siteRoot}/before-you-apply/`;
    if (sparta.language !== 'en') {
      url += `${sparta.language}/`;
    }
    url += `?campaign=${campaignId}`;
  } else {
    const campaignParts = campaignId.split('~');
    url += `${site.abpaEndpoint}`;
    url += `?requesttype=${requestType}`;
    url += `&campaignid=${campaignParts[0]}`;
    url += `&productoffercode=${campaignParts[1]}`;
    url += `&locale=${campaignParts[2]}`;
    if (queryString) {
      url += `&${queryString}`;
    }
  }
  if (catalog && catalog.marketingTrack && catalog.marketingCode) {
    url += `&mktg_track=${catalog.marketingTrack}&track=${catalog.marketingCode}`;
  }
  applyLink.URL = url;

  // add performance classes for prefetch and/or preload performance meta
  const VALID_META = ['prefetch', 'preconnect', 'prerender', 'crossorigin'];
  if (Array.isArray(performanceMeta) && performanceMeta.length > 0) {
    let performanceClasses = '';
    performanceMeta.forEach(rel => {
      if (VALID_META.indexOf(rel) !== -1) {
        performanceClasses += `spa-${rel} `;
      }
    });
    if (performanceClasses) applyLink.CLASS = `${performanceClasses}${applyLink.CLASS}`;
  } else if (typeof performanceMeta === 'string' && VALID_META.indexOf(performanceMeta) !== -1) {
    applyLink.CLASS = `spa-${performanceMeta} ${applyLink.CLASS}`;
  }
  return linkHelper(applyLink);
}

/**
 * learnMore
 * @description Builds the anchor
 * @param {Object} learnMoreLink JCR content in sparta link format
 * @param {Object} learnMoreLocal JCR content
 * @param {String} campaignId campaign id
 * @param {Object} site spaParams.siteParams
 * @param {String} performanceMeta empty string
 * @return {String} string
 */
function learnMore(learnMoreLink, learnMoreLocal, campaignId, site, performanceMeta = '') {
  learnMoreLink.URL = learnMoreUrl(learnMoreLocal, campaignId, site);

  // add performance classes for prefetch and/or preload performance meta
  const VALID_META = ['prefetch', 'preconnect', 'crossorigin'];
  if (Array.isArray(performanceMeta) && performanceMeta.length > 0) {
    let performanceClasses = '';
    performanceMeta.forEach(rel => {
      if (VALID_META.indexOf(rel) !== -1) {
        performanceClasses += `spa-${rel} `;
      }
    });
    if (performanceClasses) learnMoreLink.CLASS = `${performanceClasses}${learnMoreLink.CLASS}`;
  } else if (typeof performanceMeta === 'string' && VALID_META.indexOf(performanceMeta) !== -1) {
    learnMoreLink.CLASS = `spa-${performanceMeta} ${learnMoreLink.CLASS}`;
  }
  return linkHelper(learnMoreLink);
}

/**
 * learnMoreLink
 * @description Builds the learn more url
 * @param {Object} learnMoreLocal JCR content
 * @param {String} campaignId campaignID
 * @param {Object} site spaParams.siteParams
 * @return {String} string
 */
function learnMoreUrl(learnMoreLocal, campaignId, site) {
  let url = `${site.siteRoot}/${learnMoreLocal.path}`;
  if (learnMoreLocal.passCampaign) {
    url += `?campaign=${campaignId}`;
  }
  return url;
}

/**
 * termsAndConditions
 * @param {Object} localLink JCR content in sparta link format
 * @param {String} campaignId campaign ID
 * @param {Object} site spaParams.siteParams
 * @param {Object} sparta sparta build object
 * @param {Boolean} hasOfferTerms has offer terms
 * @param {String} termsLabel offer terms label
 * @return {String} string
 */
function termsAndConditions(localLink, campaignId, site, sparta, hasOfferTerms, termsLabel) {
  const myTermsLink = localLink;
  const campaignParts = campaignId.split('~');
  let url = `${site.siteRoot}/${site.tncUrl}`;
  if (sparta.language !== 'en') {
    url += `${sparta.language}/`;
  }
  url += `?campaignid=${campaignParts[0]}`;
  url += `&productoffercode=${campaignParts[1]}`;
  url += `&locale=${campaignParts[2]}`;
  myTermsLink.URL = url;
  if (hasOfferTerms && typeof hasOfferTerms === 'boolean') {
    myTermsLink.URL = `${url}#features`;
    myTermsLink.content = termsLabel;
  }
  return linkHelper(myTermsLink);
}

/**
 * @param {String} linkName linkName
 * @param {String} name name
 * @param {String} adaValue value to add
 * @param {String} campaignId id
 * @param {String} productOfferCode code
 * @param {String} linkText text
 * @param {Boolean} hasOfferTerms boolean
 * @return {String} string
 */
function termsAndConditionsSB(linkName, name, adaValue, campaignId, productOfferCode, linkText, hasOfferTerms) {
  let href = `/smallbusiness/credit-cards/terms-and-conditions/?campaignid=${campaignId}&productoffercode=${productOfferCode}&locale=en_US`;
  if (hasOfferTerms && typeof hasOfferTerms === 'boolean') {
    href += '#features';
  }
  return [`<a class="terms-and-conditions-card" href="javascript:void(0);" data-href=" ${href}" id="${linkName}" data-width="600" data-height="600">`, linkText, `<span class="ada-hidden">${adaValue}</span>`, '</a>'].join('');
}

/**
 * getProgramRulesLink
 *
 * @param {Object} programRulesLink JCR content in sparta link format
 * @param {Object} programRulesLabel program rules label
 * @param {Object} programRulesHref program rules href
 * @return {String} link helper
 */
function getProgramRulesLink(programRulesLink, programRulesLabel, programRulesHref) {
  const rulesLink = programRulesLink;
  rulesLink.URL = programRulesHref;
  rulesLink.content = programRulesLabel;
  return linkHelper(rulesLink);
}

/**
 * compareProduct
 *
 * @description Renders the compare checkbox
 * @param {String} campaignId
 * @param {String} compareId
 * @param {String} label
 * @param {String} product
 * @return {String}
 */
function compareProduct(campaignId, compareId, label, product, image, barkerText, barkerPosition, barkerColor) {
  const checkboxData = {
    // id: `group-compare-${campaignId}`,
    direction: 'horizontal',
    checkboxes: [{
      label: {
        text: label,
        adaText: product
      },
      checkbox: {
        attrs: {
          id: `compare-${campaignId}`,
          name: `compare-${campaignId}`,
          value: compareId,
          'data-campaign': compareId,
          'data-parent': campaignId,
          'data-product': product,
          'data-image': image,
          'data-barker-text': barkerText || '',
          'data-barker-position': barkerPosition || '',
          'data-barker-color': barkerColor || '',
          'aria-label': `${label} ${product}` // action and context for screen readers
          // ie. "Add to compare Business Advantage Travel Rewards World Mastercard® credit card"
        }
      }
    }]
  };
  return new Handlebars.SafeString(`<div class="compare-selector">${checkbox(checkboxData)}</div>`);
}

/**
 *
 *
 * @export
 * @param {String} ref ref
 * @param {Object} campaignProperties properties
 * @param {Object} options options
 * @return {String} string
 */
function cardDetails(ref = '', campaignProperties, options) {
  let data;
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (ref.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`])) {
        return '';
      }
      data.CARD_PRODUCT_DETAILS_ICON_XX = campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`])) {
        return '';
      }
      data.CARD_PRODUCT_DETAILS_HEADER_XX = campaignProperties[`CARD_PRODUCT_DETAILS_HEADER${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`])) {
        return '';
      }
      data.CARD_PRODUCT_DETAILS_CONTENT_XX = campaignProperties[`CARD_PRODUCT_DETAILS_CONTENT${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
  return null;
}

/**
 * barker
 * @todo Need to find out all the classes for the barker and check against it and add these styles
 * to the credit-cards/style-utility... seems we need to make one...
 * @description Renders the ribbon thing near the cards
 * @param {String} text text
 * @param {String} barkerPosition barker
 * @param {Object} cardData data
 * @param {Object} barkerColor blue
 * @return {String} string
 */
function barker(text, barkerPosition = 'left', cardData, barkerColor = 'blue') {
  const localBarker = createBarkerSvg(text, barkerPosition, cardData, barkerColor);
  return localBarker;
}

/**
 * now utilizes the starRating utility to keep rating code in one place
 *
 * @description code moved to credit-cards/star-rating-utility
 * @param {Object} params data
 * @return {String} string
 */
function rating(params) {
  return new Handlebars.SafeString(starRating(params));
}

/**
 * @param {String} content content
 * @param {Object} options options
 * @return {String} string
 */
function htmlEscaper(content, options) {
  if (content) {
    return content.replace(/"/g, '\\"').replace(/\n/g, '\\n');
  }
  return null;
}

/**
 * @param {Object} linkObj link
 * @param {Object} codes codes
 * @param {String} abpaEndPoint endpoint
 * @return {Object} object
 */
function updateApplyNowUrl(linkObj, codes, abpaEndPoint) {
  let href;
  href = `?requesttype=C&campaignid=${codes.campaignID}&locale=${codes.locale}&productoffercode=${codes.poCode}&groupcode=${codes.group}`;
  href = `${abpaEndPoint}${href}`;
  linkObj.URL = href;
  linkObj.content = `${linkObj.content}<span class="ada-hidden"> for ${codes.title}</span>`;
  return linkObj;
}

export { activePageScrolling, applyNow, barker, cardDetails, compareProduct, currentCampaign, currentOffer, currentOfferBasedOffQueryParams, getObjectValue, getProgramRulesLink, htmlEscaper, learnMore, learnMoreUrl, omitCampaign, omitOffers, premiumBenefitsContent, premiumBenefitsHead, premiumBenefitsIcon, rating, stripList, stripTag, termsAndConditions, termsAndConditionsSB, token, tokenPopulated, updateApplyNowUrl };
